import { render, staticRenderFns } from "./DialogDetalhes.vue?vue&type=template&id=f49a9124&scoped=true&"
import script from "./DialogDetalhes.vue?vue&type=script&lang=js&"
export * from "./DialogDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49a9124",
  null
  
)

export default component.exports